module.exports = __webpack_public_path__ + "static/media/landing-bg.fb8b20f7.jpg";